module.exports = __webpack_public_path__ + "static/media/joe-narrow.9bfeb8ae.png";